import ErrorMessages from '../../../../Centralized/common/ErrorMessages';
import ReactHtmlParser from 'react-html-parser';

const BillPayMultiHelper = {
  submitClick() {
    window.aUtils.sendAAEvent("button", "paperlessBillingTurnOn");
    this.popupCallback();
    let updatedState = { ...this.state.paperlessBilling };
    if (!_.isEmpty(updatedState.data)) {
      updatedState.accountObj = this.state.data.map(function (selectedcact) {
        return { customerAccountNumber: selectedcact, contractAccountNumber: selectedcact, };
      });
    } else {
      let cact = parseInt(this.getAccountData().contractAccountNumber);
      updatedState.accountObj = [{ customerAccountNumber: cact, contractAccountNumber: cact }];
    }
    app.logger.getLogger().info("Paperless Billing Enroll: Submit");
    if (!this.checkLoginEmail() && _.isEmpty(this.customerData.emailAddresses)) {
      let loginEmail = { value: app.appService.getUserInfo().email };
      app.settingsService.getPaperlessBillingModifyCustPrefs(loginEmail, 'I').then(
        (response) => {
          app.settingsService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData, updatedState.unselected, updatedState.selectAllflag, this.state.contractAccountCount).then(
            (res) => {
              updatedState.enrolledCount = res.length, updatedState.enrollResponse = res;
              updatedState.isPbEnrollConfirm = true;
              if (res[0].transactionOutcome) {
                errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome];
                updatedState.pbEnrollErrMsg = errorPbEnrollMsg, updatedState.enrollResponse = res;
              } else {
                updatedState.isPbEnrollConfirm = true, updatedState.isPbEnrollConfirmTest = true, updatedState.pbEnroll = false;
                if (res.length === 1 && res[0].transactionOutcome === null) {
                  updatedState.enrolledCact = res[0].accountNumber;
                }
                updatedState.isPbEnrollConfirmTest = true, updatedState.showPbPopUp = false, updatedState.enrolledCact = res.contractAccountNumber, updatedState.checked = true, updatedState.confirmObj = res;
                updatedState.pbEnroll = false;
              }
              window.scrollTo(0, 0);
              this.setState({paperlessBilling:updatedState});
            }, (error) => {
              updatedState.checked = false, updatedState.isPbEnrollConfirm = false, updatedState.pbBulkEnrollConfirm = true, updatedState.isPbEnrollConfirm = true;//updatedState.errorEnrollFlag=true;
              this.handleServiceError(error);
              this.setState({paperlessBilling:updatedState}); });
        }, (error) => {
          updatedState.checked = false,
            this.handleServiceError(error);
          this.setState({paperlessBilling:updatedState});

        } );
      }
    else {
      app.settingsService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData, updatedState.unselected, updatedState.selectAllflag, this.state.contractAccountCount).then(
        (res) => {
          updatedState.enrolledCount = res.length, updatedState.enrollResponse = res;
          let errorPbEnrollMsg = '';
          if (res[0].transactionOutcome) {
            errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome], updatedState.pbEnrollErrMsg = errorPbEnrollMsg, updatedState.enrollResponse = res;
          } else {
            updatedState.isPbEnrollConfirmTest = true, updatedState.pbEnroll = false;
            if (res.length === 1 && res[0].transactionOutcome === null) {
              updatedState.enrolledCact = res[0].accountNumber; }
            updatedState.enrolledCact = res.contractAccountNumber, updatedState.confirmObj = res, updatedState.checked = true, updatedState.pbEnroll = false;
          }
          window.scrollTo(0, 0);
          this.setState({paperlessBilling:updatedState});
        },
        (error) => {
          updatedState.checked = false, updatedState.isPbEnrollConfirm = false, this.handleServiceError(error);
          this.setState({paperlessBilling:updatedState});
        }
      );
    }
  },
  //for de enroll
  submitDeenrollClick () {
    window.aUtils.sendAAEvent("button","paperlessBillingTurnOff");
    const updatedState = { ...this.state.paperlessBilling };
    let currPaprRecord = this.props.paprRecord || this.props.desinglePaprRecord;
    let ebillpaprRecord = this.state.ebillpaprRecord;  

    app.logger.getLogger().info("Paperless Billing DeEnroll: Submit");
    app.settingsService.getPaperlessBillingDeEnrollDetails(this.getAccountData().bpNumber, ebillpaprRecord.record, app.appService.getUserInfo().profileData, this.getAccountData().contractAccountNumber).then(
      (res) => {
        let errorPbMsg='';
        updatedState.confirmObj = res,updatedState.checked = false, updatedState.pbDeEnroll = false, updatedState.deEnrollConfirmPopup = true, updatedState.yesCancelDeEnroll = true;//to close turn off popup 
        window.scrollTo(0, 0);
        // window.location.reload();
        this.setState({paperlessBilling:updatedState});
        this.setState(updatedState);
      },
      (error) => {
        updatedState.checked = true,updatedState.isPbDeEnrollConfirm=false,        
        this.handleServiceError(error);
        this.setState({paperlessBilling:updatedState});
      }
    );

  },
  getCustomerData(contractAccNo, bpNumber,popUpFlag) {
    app.appService.setSessionstorage('billPayIdentifier',{'pageReload':true,'currentPage':this.state.currentPage});
    let updatedState = { ...this.state.paperlessBillingData };
    app.settingsService.getCustomerPreferencesMulti(bpNumber, contractAccNo, false).then(
      (res) => {
        this.customerData.emailAddresses = res.record;
        this.multiPaprRec = res.record;
        let emails = [];
        if (res && res.record.length) {
          res.record.map((record) => {
            emails.push(record.email_id);
            if (record.record_guid !== null && record.category === "PAPR") {
              updatedState.enrolledEmail = record.email_id;
              updatedState.enrolledEmailObj = record;
            }
            if (record.standardIndicator === "X") {
              updatedState.primaryEmail = record.email_id;
            }
          });
        }
        updatedState.emails = emails;
        app.appService.setLocalStorage('pbemails', emails);
        switch(popUpFlag){
          case 'enroll':{
            this.setState({ paperlessBillingData: updatedState,paperlessBilling: { pbEnroll: true } });
            break;
          }
          case 'deEnroll':{
            this.setState({ paperlessBillingData: updatedState });
            break;
          }
            case 'viewEdit':{
            this.setState({ paperlessBillingData: updatedState });
            break;
          }
        }
      }), (error) => {
        this.handleServiceError(error);
      };  },
      //---ebill----get enrolled email------for multi account------
  getPaprEnrolledEmail(contractAccNo, bpNumber, popUpFlag) {
    //let updatedState = { ...this.state.paperlessBillDeEnrollData };
    let mainBpNumber = app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber;
    app.settingsService.getPaprEnrolledEmailPreferencesMulti(bpNumber, contractAccNo, false).then(
      (response) => {
        //this.paprEnrolledEmailData.emailAddresses = res.record;
        //this.ebillmultiPaprRec = res.record;
        this.setState({ ebillpaprCount: response.customerEbillPreferences.results[0].count });
        let res = response.customerEbillPreferences.results[0].qryObjSumQryBPChnlSumNav.results;
        app.appService.setSessionstorage('pbBuPartner', res[0].buPartner);
        app.appService.setSessionstorage('pbBuPartner2', res[0].buPartner2);
        let ebillpaprRecord={record:[]}, ebillpaprSold={record:[]}, ebillpaprAuth={record:[]};
        res.map((record) => {
          let result=record.qryBPChnlSumQryPreSumNav.results;
            result.map((result) => {
            ebillpaprRecord.record.push(result);
            (mainBpNumber === record.buPartner || record.buPartner2) ? ebillpaprSold.record.push(result) : ebillpaprAuth.record.push(result);
            });
        });
        this.setState({ebillpaprRecord:ebillpaprRecord, ebillpaprSold:ebillpaprSold, ebillpaprAuth:ebillpaprAuth });
        let preferenceData =this.getFormattedPreferenceData(ebillpaprSold, 'soldTo');
        let preferenceDataAuth = this.getFormattedPreferenceData(ebillpaprAuth, 'AuthTo');
        this.setState({preferenceData:preferenceData, preferenceDataAuth:preferenceDataAuth });
        switch(popUpFlag){
          case 'deEnroll':{
            this.setState({ paperlessBilling: { pbDeEnroll: true } });
            break;
          }
          case 'viewEdit':{
            this.setState({ paperlessBilling: { viewEditPopUp: true } });
            break;
          }
        }
      }), (error) => {
        this.handleServiceError(error);
      };
  },
  checkLoginEmail() {
    let isLoginEmail = false;
    let loginEmail = app.appService.getUserInfo().email;

    _.each(this.state.paperlessBillingData.emails, function (record) {
      if (record.email === loginEmail)
        isLoginEmail = true;
    });
    return isLoginEmail;
  },
  handleServiceError(error) {
    app.logger.getLogger().info("Paperless Billing Enroll: Handle service error");
    app.logger.getLogger().info(error);
    this.setState({ isGlobalError: true });
  },
  overlayFocusController() {
    if(this.state.paperlessBilling.pbEnroll || this.state.paperlessBilling.pbDeEnroll || this.state.paperlessBilling.viewEditPopUp || this.state.paperlessBilling.isPbEnrollConfirm ) {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.position = this.initialPositionValue;
      document.body.style.removeProperty("width");
    }
  },
  searchOrRefreshSetData(response,searchOrRefreshFlag){
    let accountData = response.customerAccountListData;
    let errorCode = response.errorCode ? response.errorCode : '';
    switch (searchOrRefreshFlag) {
      case 'search': {
        window.aUtils ? window.aUtils.sendAAEvent("account | searchbar", `settings|billing_payments|none|multi_grid|page|searchtype=accountnum`) : null;                                         
        this.setState({ settingsTableData: accountData, errorCode: errorCode, showSpinner: false, searchMode: true, noOfAccounts: response.totalCustomerAccountCount });
      }
        break;
      case 'refresh': {
        let tableData = this.state.settingsTableData;
        let index = _.findIndex(tableData, function (acctVal) {
          return acctVal.contractAccountNumber = accountData[0].contractAccountNumber;
        });
        tableData[index].eligibilityData = accountData[0].eligibilityData;
        this.setState({ settingsTableData: tableData, errorCode: errorCode, showSpinner: false });
      }
        break;
      default: {
        this.setState({ settingsTableData: accountData, errorCode: errorCode, showSpinner: false , noOfAccounts: response.totalCustomerAccountCount });
      }}
  },
  getSearchCALabelText(searchLabelContent){
    let searchLabelRgx = new RegExp('<span id="ca-label">([^]*?)</span>', 'g'), searchPlaceHolderRgx = new RegExp('<span id="ca-placeholder">([^]*?)</span>', 'g'),
    searchLabel = searchLabelRgx.exec(searchLabelContent.body), searchPlaceHolder = searchPlaceHolderRgx.exec(searchLabelContent.body); /*searchLabelContent.body.match(searchPlaceHolderRgx);billHelpRgx.exec(content.body)*/
    let searchBoxContent = {labelContent: searchLabel?ReactHtmlParser(searchLabel[1]):"", placeholder: searchPlaceHolder?ReactHtmlParser(searchPlaceHolder[1]):""};
    return searchBoxContent;
  },
  getFormattedPreferenceData(Obj, type){
    let preferenceData={emailSet:[]};
    _.each(Obj.record, function(email){
        let preferenceSavedDateMilliSec = email.validFromDate ? email.validFromDate.indexOf('/')===0 ? email.validFromDate.slice(6,-2) : email.validFromDate : null;
        let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
        let data={
          solution: 'U', objectType: 'ISUACCOUNT', objectKey: email.relationshipObjectKey || '', contractAccountNumber: email.contractAccountNumber, category: 'PAPR', messageType: 'EBILL',
          buPartner: email.buPartner, channel: 'INT', recordGUID: email.recordGUID || 'NEW', email: email.value || "", type: type,
          validFromDate: email.validFromDate, validFromTime: email.validFromTime, validToDate: email.validToDate, validToTime: email.validToTime,
            removeFromDate: preferenceSavedEDMDate, buPartner2: email.buPartner2, relationshipObjectType: email.relationshipObjectType, relationshipObjectKey: email.relationshipObjectKey
        };
          preferenceData.emailSet.push(data);
    });
   return preferenceData; },
  //-----------------ebill-----ViewEditConfirmPopup------
   closeViewEditConfirmPopup(){ window.location.reload(); } 
};


export default BillPayMultiHelper;
